import { css } from "@emotion/react";
import { Loading } from "@podtrac/common/components/Loading";
import { scaleOrdinal } from "d3-scale";
import { schemeCategory10 } from "d3-scale-chromatic";
import { DateTime } from "luxon";
import React from "react";
import { useEpisodeGrowth } from "../store/episode-growth";
import { useShow } from "../store/show";
import EpisodeGrowthChart from "./EpisodeGrowthChart";
import { DownloadsLabel } from "../shared/DownloadsLabel";

const numberFormat = new Intl.NumberFormat().format;
const percentFormat = new Intl.NumberFormat(undefined, { style: "percent", signDisplay: "always" })
    .format;

export default function EpisodeGrowth({ accountID, showID }) {
    const { data: growth = [] } = useEpisodeGrowth(accountID, showID) || {};
    const { data: show } = useShow(accountID, showID) || {};

    const colorScale = scaleOrdinal(schemeCategory10);

    return (
        <>
            {growth && <EpisodeGrowthChart data={growth} colors={colorScale} />}
            <table
                className="table"
                css={css`
                    width: 100%;
                `}
            >
                <thead>
                    <tr>
                        <th css={css``}>Title</th>
                        <th
                            css={css`
                                text-align: right;
                            `}
                        >
                            Published
                        </th>
                        {Array.from({ length: 7 }).map((_, i) => (
                            <th
                                key={i}
                                css={css`
                                    text-align: right;
                                `}
                            >
                                {i + 1}-Day <DownloadsLabel />
                            </th>
                        ))}
                        { !show.youTubeShow ? (
                            <th
                                css={css`
                                    text-align: right;
                                `}
                            >
                                Growth vs. avg
                            </th>
                        ) : (
                            ""
                        )}
                    </tr>
                </thead>
                <tbody>
                    {growth &&
                        growth.map &&
                        growth.map(e => (
                            <tr key={e.episodeTitle}>
                                <td style={{ textAlign: "left", display: "flex" }}>
                                    <div
                                        style={{
                                            flexShrink: 0,
                                            width: "0.8em",
                                            height: "0.8em",
                                            marginRight: "0.25em",
                                            marginTop: "0.2em",
                                            background: colorScale(e.episodeTitle)
                                        }}
                                    />
                                    <div
                                        css={css`
                                            white-space: nowrap;
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                            max-width: 30ch;
                                        `}
                                    >
                                        {e.episodeTitle}
                                    </div>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                    {DateTime.fromISO(e.publicationDate, {
                                        zone: "utc"
                                    }).toLocaleString(DateTime.DATE_SHORT)}
                                </td>
                                {Array.from({ length: 7 }).map((_, i) => (
                                    <td key={i} style={{ textAlign: "right" }}>
                                        {e.days[i].cumulativeDownloads
                                            ? numberFormat(e.days[i].cumulativeDownloads)
                                            : "-"}
                                    </td>
                                ))}

                                { !show.youTubeShow ? (
                                    <td style={{ textAlign: "right" }}>
                                        <Growth growth={e.growth7Day} />
                                    </td>
                                ) : (
                                    ""
                                )}
                            </tr>
                        ))}
                </tbody>
            </table>
            {!growth && <Loading height="30vh" />}
        </>
    );
}

function Growth({ growth }) {
    return growth ? (
        <div
            css={css`
                color: ${growth >= 0 ? "#090" : "#c00"};
            `}
        >
            {percentFormat(growth)}
        </div>
    ) : null;
}
